import '../pages/stylesheets/application.scss';
import './channels/player';
